import { render, staticRenderFns } from "./DossierConvert.vue?vue&type=template&id=00789cf0&scoped=true&"
import script from "./DossierConvert.vue?vue&type=script&lang=js&"
export * from "./DossierConvert.vue?vue&type=script&lang=js&"
import style0 from "./DossierConvert.vue?vue&type=style&index=0&id=00789cf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00789cf0",
  null
  
)

export default component.exports